export default __webpack_public_path__ + "static/media/Black Vash.e871b4d1.jpg";